import type { ReactNode } from "react";
export default function LeagueRuleCard({ title, icon, children }: { title: string; icon: string; children: ReactNode }) {
  return <section className="league-rule-card">
    <div className="league-rule-card-title"><span className="material-symbols-outlined" aria-hidden="true">{icon}</span><h3>{title}</h3></div>
    <div className="league-rule-card-body">{children}</div>
  </section>;
}
